import React, { useEffect, useRef, useState } from "react";
import LeftMenu from "../AnalyticsModule/Left";
import { RunnerUpHeader } from "../../ui";
import { Validators } from "../../library/utilities/Validator";
import UploadFile from "../../library/components/FileUpload";
import TextAreaField from "../../library/components/textarea/index";
import {
  ALERT_TYPE_SUCCESS,
  FILED_IS_REQUIRED,
} from "../../constants/constants";
import DateInput from "../../library/components/DateInput";
import Button from "../../library/components/Button";
import { useSubmitObjectStoreUploadMutation } from "../../services/objectStoreServices";
import { createAlert } from "../../features/alert/alerts";
import { useDispatch } from "react-redux";
import { useDeleteInstructionMutation, useGetAllInstructionRequestQuery, usePostInstructionMutation } from "../../services/announceElection";
import Table from '../../ui/datatable/DataTable'
import EditRelease from "./editRelease";
import Modal from '../../library/components/Modal/modal'
import edit_instruction from "../../dashboardicon/edit_instruction.svg"
import delete_instruction from "../../dashboardicon/delete_instruction.svg"
import MultiSelectCheckBox from "../../ui/multiSelectCheckbox/MultiSelectCheckBox";
import ReactSelect from "../../ui/reactSelect";
import RunnerUpHeaderNew from "../../ui/runnerUpHeader/RunnerUpHeaderNew";

const columns1 = [
  {
    Header: 'S.No',
    accessor: 'S_No',
  },
  {
    Header: 'Uploaded Date',
    accessor: 'uploaded_date',
  },
  {
    Header: 'Subject',
    accessor: 'subject',
  },
  {
    Header: 'Issue Date',
    accessor: 'issue_date',
  },
  {
    Header: 'Expiry Date',
    accessor: 'expiry_date',
  },
  {
    Header: 'No Of Downloads',
    accessor: 'no_of_downloads',
  },
  {
    Header: 'Is Active',
    accessor: 'is_active',
  },
  {
    Header: 'Action',
    accessor: 'edit',
  },
]

const userList = [
  {value:"ceo", label:"CEO Level"},
  {value:"deo", label:"DEO Level"},
  {value:"ero", label:"Electoral Registration Officer"},
  {value:"ro", label:"Returning Officer"},
  {value:"nodal", label:"Nodal Officer"},
  {value:"record", label:"Record Officer"},
  {value:"unit", label:"Unit Officer"},

]

const UploadRelease = () => {
  const [data, setData] = useState({
    dateOfIssue: "",
    dateOfExpiry: "",
    releaseDocument: "",
    remarks: "",
  });
  const [errorValue, setErrorValue] = useState({});
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [userId,setuserId]= useState()
  const [isVisible, setisVisible] = useState(false)
  const [instructionData,setInstructionData] = useState([]);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [selected, setSelected] = useState([]);
  var [uploadData, response] = useSubmitObjectStoreUploadMutation();
  const [postInstruction, datap] = usePostInstructionMutation();
  const {data:GetAllInstruction, refetch} = useGetAllInstructionRequestQuery()
  const [deleteInstructionData,dataD]=useDeleteInstructionMutation()
  const ref = useRef();
  const dispatch = useDispatch();
  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };

  const getErrorValue = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setErrorValue({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setErrorValue(error);
    }
  };

  const convertDate = (date) => {
    var priorDate = new Date(
      new Date(date).setDate(new Date(date).getDate() + 1)
    );
    return priorDate;
  };

  const subtractDate = (date) => {
    var priorDate = new Date(
      new Date(date).setDate(new Date(date).getDate() - 1)
    );
    return priorDate;
  };
  
  const onSubmitData = () => {
    let error = {};
    if (!data?.userList || data?.userList === "" || data?.userList.length == 0 ) {
      error["userList"] = "This Field is required";}

    if (!data?.dateOfIssue || data?.dateOfIssue === "") {
      error["dateOfIssue"] = "This field is required";
    }

    if (!data?.dateOfExpiry || data?.dateOfExpiry === "") {
      error["dateOfExpiry"] = "This Field is required";
    }

    if (!data.remarks || data.remarks === "") {
      error["remarks"] = "This Field is required";
    }

    if (!data.releaseDocument || data.releaseDocument === "") {
      error["releaseDocument"] = "This Field is required";
    }

    if (Object.keys(error).length) {
      setErrorValue(error);
      return;
    }

    var roleList = []
    data?.userList?.map((item)=>{
      console.log(item)
      roleList.push(item?.value)
    })

    let formdata = new FormData();
    let files = data?.releaseDocument;
    formdata.append("bucketName", "");
    formdata.append("file", files);
    formdata.append("fileType", files?.type);
    formdata.append("fileName", files?.name);
    formdata.append("stateCode", "master");
    formdata.append("acNo", data.Selectedcons);
    formdata.append("type", `ETPBMS`);

    if (formdata !== null && formdata !== {} && data?.releaseDocument ) {
      uploadData(formdata)
        .then((res) => {
          if (res?.error) {
            setIsFileUpload(false);
          } else {
            setIsFileUpload(false);
            ref.current.removeFile();
            postInstruction({
              filePath: res?.data?.refId,
              dateOfIssue: data?.dateOfIssue,
              dateOfExpiry: data?.dateOfExpiry,
              subject: data?.remarks,
              allowedRoles:roleList,
            })
              .unwrap()
              .then((responseData) => {
                onSuccess(responseData?.data?.message);
                setData({});
                refetch()
              })
              .catch((err) => {});   
          }
        })
        .catch((err) => {
          setIsFileUpload(false);
        });
    } else {
      setIsFileUpload(false);
    }
  };


  const EditInstruction = (e) => {
    setisVisible(true)
    var temp = e.currentTarget.name
    setuserId(temp)
  }

  const deleteInstruction = (e) =>{
    var temp = e.currentTarget.name;
    deleteInstructionData({
      id:temp
    })
  }

  useEffect(()=>{
    if(dataD.isSuccess){
      refetch()
    }
  },[dataD.isSuccess])

  useEffect(()=>{
    if(GetAllInstruction){

      var instruction = [];
      GetAllInstruction?.payload?.map((item,i)=>{
        instruction.push({
          S_No:i+1,
          uploaded_date:item?.uploadedOn,
          subject:item?.subject,
          issue_date:item?.dateOfIssue,
          expiry_date:item?.expiryDate,
          no_of_downloads:item?.downloadAttempts,
          is_active:item?.isActive,
          edit: <><img name={item?.id} src={edit_instruction} style={{height:"30px", width:"30px"}} onClick={EditInstruction} /><img name={item?.id} src={delete_instruction} style={{height:"30px", width:"30px"}} onClick={deleteInstruction} /></>,
        })
      })
setInstructionData(instruction);
setTotalNoOfRecords(GetAllInstruction?.payload?.length)
    }
  },[GetAllInstruction])

  return (
    <LeftMenu>
      <>
        <div className="container-fluid box shadow ">
          <RunnerUpHeaderNew title="Upload Instructions." />

          <div className="row  mt-1">
            <div className="col-md-4 mt-4">
              <label className="requiredMark">Date Of Issue</label>
            </div>

            <div className="col-md-8 mt-3 nullification">
              <DateInput
                label=""
                inputClass="col-md-6"
                value={data?.dateOfIssue}
                onChange={(val) => handleChange("dateOfIssue", val)}
                name="dateOfIssue"
                validators={[
                  {
                    check: Validators.required,
                    message: "This field is required",
                  },
                ]}
                getError={(val) => getErrorValue("dateOfIssue", val)}
                Error={Error}
              />
              {errorValue.dateOfIssue && (
                <div className="text-danger errormsg ml-3">
                  {errorValue.dateOfIssue}
                </div>
              )}
            </div>
          </div>
          <div className="row  mt-1">
            <div className="col-md-4 mt-4">
              <label className="requiredMark">Date Of Expiry</label>
            </div>

            <div className="col-md-8 mt-3 nullification">
              <DateInput
                label=""
                inputClass="col-md-6"
                value={data?.dateOfExpiry}
                disabled={data?.cutOffDate === "" || data?.cutOffDate === null}
                onChange={(val) => handleChange("dateOfExpiry", val)}
                name="dateOfExpiry"
                min={
                  data?.dateOfIssue &&
                  convertDate(data?.dateOfIssue).toISOString().split("T")[0]
                }
                validators={[
                  {
                    check: Validators.required,
                    message: "This field is required",
                  },
                ]}
                getError={(val) => getErrorValue("dateOfExpiry", val)}
                Error={Error}
              />
              {errorValue.dateOfExpiry && (
                <div className="text-danger errormsg ml-3">
                  {errorValue.dateOfExpiry}
                </div>
              )}
            </div>
          </div>
          <div className="row  mt-1">
            <div className="col-md-4 mt-4">
              <label className="requiredMark">Select User Type</label>
            </div>

            <div className="col-md-8 nullification">
             <ReactSelect
                // disabled={false}
                name="userList"
                label=""
                placeholder="Select User Type"
                options={userList}
                valueKey="value"
                labelKey="label"
                labelClass=""
                inputClass="col-md-6"
                getOptionLabel={(data) => data.label}
                getOptionValue={(data) => data.value}
                value={data?.userList?.length>0 ? data?.userList :null}
                isMulti={true}
                handleChange={(val) => handleChange("userList", val)}
                validators={[
                    {
                      check: Validators.required,
                      message: "This field is required",
                    },
                  ]}
                  getError={(val) => getErrorValue("userList", val)}
                  Error={errorValue}
              ></ReactSelect>
            </div>
           
          </div>
          <div className="row mt-1 my-4">
            <div className="col-md-4 mt-2 ">
              <label className="requiredMark">Upload File</label>
            </div>
            <div className="col-md-8">
              <UploadFile
                name="releaseDocument"
                required={true}
                labelClass="col-10 box"
                onChange={(val) =>
                  handleChange("releaseDocument", val.target.files[0])
                }
                accept=".jpeg,.jpg, .png, .pdf"
                validTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                size={5000}
                reference={ref}
                validators={[
                  {
                    check: Validators.required,
                    message: "this field is required",
                  },
                ]}
                getError={(val) => getErrorValue("releaseDocument", val)}
                Error={errorValue}
              />
              <p className="text-danger px-3">
                (only .jpg, jpeg, .png and .pdf extension supported)
              </p>
            </div>
          </div>
          <div className="row  mt-1">
            <div className="col-md-4 mt-4">
              <label className="requiredMark">Subject</label>
            </div>

            <div className="col-md-8 nullification">
              <TextAreaField
                type="textrea"
                name="remarks"
                placeholder="Enter Reason"
                rows="4"
                cols="40"
                maxLength="500"
                value={data?.remarks}
                onChange={(val) => handleChange("remarks", val)}
                getError={(value) => getErrorValue("remarks", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  },
                  {
                    check: Validators.required,
                    message: "This field is required",
                  },
                  {
                    check: Validators.nospecialReason,
                    message: "Special Character are not allowed",
                  },
                ]}
                getErrorValue={(val) => getErrorValue("remarks", val)}
                Error={errorValue}
              ></TextAreaField>

              <div className="col-md-6" style={{ marginTop: "-16px" }}>
                <p className="text-danger ml-1">*max length 500 characters</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 offset-4 request_button">
              <Button
                value="Submit"
                onClick={() => onSubmitData()}
                id="abc"
                btnClass="btn-class mb-3"
              />
            </div>
          </div>
        </div>
        <div className="container box my-1">
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns1}
          emptyMessage="No Record Found"
          records
          data={instructionData?.length === 0 ? [] : instructionData}
          size={10}
          tableClassNameCheck="contenttable-eroll"
          pagination
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
        </div>
        <Modal
            show={isVisible}
            className=""
            onClose={() => setisVisible(false)}
            modalTitle="Update Instructions"
            size={800}
          >
            <EditRelease id={userId} refetch={refetch} setisVisible={setisVisible}/>
          </Modal>
      </>
    </LeftMenu>
  );
};

export default UploadRelease;
